import React from 'react';
import { Link } from 'react-router-dom';
import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-about">
          <h3>About Mehar Tour & Travels</h3>
          <p>
            Your trusted travel companion for Himachal & Jammu-Kashmir. 
            We provide customized tour packages for families, couples, groups, and adventure lovers.
          </p>
        </div>

        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/tours">Tours & Packages</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p>
  <strong>Phone:</strong>{" "}
  <a href="tel:+918580593956">+91 8580593956</a>
</p>

<p>
  <strong>Email:</strong>{" "}
  <a href="mailto:mehartours@gmail.com">
    mehartours@gmail.com
  </a>
</p>

<p>
  <strong>Address:</strong>{" "}
  <a
    href="https://www.google.com/maps/dir/31.0933349,77.1349612/Jamuna+Bhawan,+Chakkar+-+Boileauganj+Bypass+Rd,+Sandal+Estate,+Lower+Chakkar,+Chakkar,+Shimla,+Himachal+Pradesh+171005/@31.0916544,77.1328445,17z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3905793d20bd7e8d:0x734e6170c2ecbee6!2m2!1d77.1358879!2d31.0916914?entry=ttu&g_ep=EgoyMDI2MDYyOS4wIKXMDSoASAFQAw%3D%3D"
    target="_blank"
    rel="noopener noreferrer"
  >
    Jamuna Bhawan,Lower Chakkar,Shimla Himachal Pradesh 171005
  </a>
</p>
        </div>

        <div className="footer-social">
          <h3>Follow Us</h3>
          <div className="social-icons"style={{marginBottom:"10px"}}>
          <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
  <i className="fab fa-facebook-f"></i>
</a>

<a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
  <i className="fab fa-instagram"></i>
</a>

<a href="https://twitter.com/" target="_blank" rel="noreferrer">
  <i className="fab fa-twitter"></i>
</a>
          </div>
          <div>
            <a href="/admin-login" className="admin-link"style={{textDecoration:"none",color:"#fff"}}>Admin Login</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
  <div>
    <p>© {new Date().getFullYear()} Mehar Tour And Travels. All rights reserved.</p>
  </div>

  <div>
    <p>
      Website Designed & Developed by{" "}
      <a href="mailto:bansalbhanwna@gmail.com">
        Bhawna
        bansalbhanwna@gmail.com
      </a>
    </p>
  </div>
</div>
    </footer>
  );
}

export default Footer;
